import { InAppNotificationType } from '@interfaces';
import { getCandidateVerificationRoute } from './notifications.registry.helpers';
import { NotificationRegistry } from './notifications.registry.types';

type ManagerNotificationType =
  | InAppNotificationType.CONSULTANT_STARTED_NEW_CANDIDATE_VERIFICATION
  | InAppNotificationType.CANDIDATE_REQUESTED_STOPPING_VERIFICATION
  | InAppNotificationType.CONSULTANT_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST
  | InAppNotificationType.CONSULTANT_SAVED_CANDIDATE_VERIFICATION_RESULT
  | InAppNotificationType.CONSULTANT_ISSUED_CANDIDATE_VERIFICATION_DECISION
  | InAppNotificationType.CANDIDATE_VERIFICATION_DELETED;

export const managerNotificationRegistry: NotificationRegistry<ManagerNotificationType> = {
  [InAppNotificationType.CONSULTANT_STARTED_NEW_CANDIDATE_VERIFICATION]: {
    recipientGroup: 'manager',
    actionKey: 'candidate-verification',
    autoReadOn: ['cvm-details'],
    icons: [{ name: 'assignment', className: 'primary-icon', fontSet: 'material-icons-outlined' }],
    getRoute: (notification, myself) => getCandidateVerificationRoute(notification, myself, 'basic-details'),
  },
  [InAppNotificationType.CANDIDATE_REQUESTED_STOPPING_VERIFICATION]: {
    recipientGroup: 'manager',
    actionKey: 'candidate-verification',
    autoReadOn: ['cvm-details'],
    icons: [{ name: 'block', className: 'negative-icon', fontSet: 'material-icons-outlined' }],
    getRoute: (notification, myself) => getCandidateVerificationRoute(notification, myself, null),
  },
  [InAppNotificationType.CONSULTANT_CHANGED_CANDIDATE_VERIFICATION_PROCEDURES_LIST]: {
    recipientGroup: 'manager',
    actionKey: 'candidate-verification',
    autoReadOn: ['cvm-details'],
    icons: [{ name: 'list_alt', className: 'action-icon', fontSet: 'material-icons-outlined' }],
    getRoute: (notification, myself) => getCandidateVerificationRoute(notification, myself, 'result'),
  },
  [InAppNotificationType.CONSULTANT_SAVED_CANDIDATE_VERIFICATION_RESULT]: {
    recipientGroup: 'manager',
    actionKey: 'candidate-verification',
    autoReadOn: ['cvm-details'],
    icons: [{ name: 'rule', className: 'positive-icon', fontSet: 'material-icons-outlined' }],
    getRoute: (notification, myself) => getCandidateVerificationRoute(notification, myself, 'result'),
  },
  [InAppNotificationType.CONSULTANT_ISSUED_CANDIDATE_VERIFICATION_DECISION]: {
    recipientGroup: 'manager',
    actionKey: 'candidate-verification',
    autoReadOn: ['cvm-details'],
    icons: [{ name: 'gavel', className: 'action-icon', fontSet: 'material-icons-outlined' }],
    getRoute: (notification, myself) => getCandidateVerificationRoute(notification, myself, 'result'),
  },
  [InAppNotificationType.CANDIDATE_VERIFICATION_DELETED]: {
    recipientGroup: 'manager',
    actionKey: 'noop',
    clickableOverride: false,
    icons: [{ name: 'delete_forever', className: 'negative-icon', fontSet: 'material-icons-outlined' }],
    getRoute: () => null,
  },
};
